module.exports = __webpack_public_path__ + "img/2.813ee842.svg";